import React, { Component } from 'react';
import { loadMenu  } from "../../api"
import '../../index.scss';


class FAQList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            menuJson: "",
            data: {},
            pid: this.props.pid
        }
    }

    loadMenu = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            loadMenu( this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, menuJson: JSON.parse(d2.menuJson), loading: false});      
                }
            });
        } else if (this.props.item) {
            this.setState({ menuJson: this.props.item, loading: false}); 
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadMenu();
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            const item = this.state.menuJson;
            return (
                <section className="faq-section section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h2>{item.title}</h2>
                                <div className="accordion theme-accordion" id="accordionExample">

                                    { item && item.items.map((childItem, index ) =>                                                                         
                                        <div className="card">
                                        <div className="card-header" id={`heading${index}`}>
                                            <h5 className="mb-0">
                                                <button className="btn btn-link" type="button" data-toggle="collapse"
                                                        data-target={`#collapse${index}`} aria-expanded="true"
                                                        aria-controls={`collapse${index}`}>
                                                    {childItem.questionText}
                                                </button>
                                            </h5>
                                        </div>

                                        <div id={`collapse${index}`} className="collapse show" aria-labelledby={`heading${index}`}
                                                data-parent="#accordionExample">
                                            <div className="card-body">
                                                <p>{childItem.answerText}</p>
                                            </div>
                                        </div>
                                    </div>                                                                                        
                                    )}    

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        )
    }
    }
}

export default FAQList;